export default __webpack_public_path__ + "static/hurtConsoling-e2e7c9b4c2acae25470b93d6b8a9639f.svg";